import { Block, useStyletron } from "@mezo-org/mezo-clay"

import {
  PoolNameCellContent,
  PoolRewardsCellContent,
  PoolTvlCellContent,
} from "#/ui/LiquidityPage/Pools"

export default function SelectedPool({
  poolName,
  tvl,
  rewards,
}: {
  poolName: string
  tvl: string
  rewards: string
}) {
  const [css, theme] = useStyletron()

  return (
    <Block
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      backgroundColor="backgroundSecondary"
      paddingTop="scale800"
      paddingBottom="scale800"
      paddingLeft="scale500"
      paddingRight="scale500"
      className={css({ borderRadius: theme.borders.radius400 })}
    >
      <PoolNameCellContent name={poolName} />
      <PoolTvlCellContent tvl={tvl} />
      <PoolRewardsCellContent rewards={rewards} />
    </Block>
  )
}
